import {Semaphore} from "./shared-semaphore";

export class SingleEventSemaphore extends Semaphore {
  constructor() {
    super(1);
  }
}
